export function filterDropdown() {
  const dropdowns = document.querySelectorAll('.js-filter-dropdown');

  if (!dropdowns) {
    return false;
  }

  [].slice.call(dropdowns).forEach(dropdown => {
    dropdown.addEventListener('click', handleFilterDropdown);
  });
}

function handleFilterDropdown(e) {
  e.preventDefault();

  const button = e.target.closest('.js-filter-dropdown');

  if (!button) {
    return false;
  }

  const isPressed = button.getAttribute('aria-pressed');
  const icon = button.querySelector('i.fal');

  if (isPressed) {
    button.removeAttribute('aria-pressed');
    icon.classList.add('fa-angle-down');
    icon.classList.remove('fa-times');

    return;
  }

  button.setAttribute('aria-pressed', 'true');
  icon.classList.add('fa-times');
  icon.classList.remove('fa-angle-down');
}
